module.exports = __webpack_public_path__ + "static/media/forbes.c5062b1e.svg";